<template>
  <div
    :class="{big: show}"
    id="altitude-preview"
    @click="show = false"
  >
    <img
      :src="imgSrc"
      class="bounce"
      @click.stop="show = !show"
      alt="Rangos altitudinales de esta cuenca"
      title="Rangos altitudinales de esta cuenca"
    />
  </div>
</template>

<script>
export default {
  name: 'MobileAltitudePreview',

  props: {
    watershedId: {
      required: true,
    },
  },

  data() {
    return {
      show: false,
    };
  },

  computed: {
    imgSrc() {
      return `data/${this.watershedId}/cuenca.png`;
    },
  },
};
</script>

<style lang="scss" scoped>
#altitude-preview {
  overflow: hidden;
  position: relative;
  pointer-events: none;

  img {
    pointer-events: auto;
    display: block;
    height: 50px;
    position: absolute;
    right: 0px;
    bottom: 0px;
    transition: width 0.3s, height 0.3s;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  }

  &.big {
    pointer-events: auto;
    background-color: rgba(0, 0, 0, .5);

    img {
      height: 90%;
    }
  }
}
</style>
